<div class="streamline m-b m-l" *ngIf="data?.length">
  <div class="sl-item" *ngFor="let position of data | sort:'value':false">
    <div class="sl-content-wrapper">
      <div class="sl-left">
        <i class="fa-solid fa-gear"></i>
      </div>
      <div class="sl-content">
        <span class="position-name pointer" (click)="onSelect(position)">
          {{position.name | translate}}
        </span>
        <div class="m-l-sm sl-date pull-right">
          {{ position.value }} {{ (position.value > 1 ? 'DASHBOARD.days' : 'DASHBOARD.day') | translate}}
        </div>
      </div>
    </div>
  </div>
</div>
<div class="padding" *ngIf="!data?.length">
  <gp-message text="COMMON.no_chart_data" type="info"></gp-message>
</div>
